import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getUserAudioFile, getUserAudioList } from '../api';

class Speeches extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userAudioList: []
        }

        this.getUserAudioList(this.props.uuid);
        this.audioElem = new Audio();
    }


    render() {
        return (
            <div style={{ width: "95%", height: "60vh", overflowY: "scroll", margin: "0 auto" }}>
                <table style={{ width: "100%" }} className="table table-striped table-secondary table-hover">
                    <thead className="thead-dark">
                        <tr>
                            <th>#</th>
                            <th>Prompt</th>
                            <th>
                                <div className="text-center">
                                    <span>
                                        Action
                                    </span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.userAudioList.map(
                                (listValue, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="align-middle">{index + 1}</td>
                                            <td className="align-middle">{listValue.prompt}</td>
                                            <td className="align-middle">
                                                <audio controls src={getUserAudioFile(this.props.uuid, listValue.audio_id)} preload="none">
                                                </audio>
                                            </td>
                                        </tr>
                                    );
                                })
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    getUserAudioList = (uuid) => {
        getUserAudioList(uuid).then(res => res.json())
            .then(
                res => {
                    if (res.success) {
                        this.setState({ userAudioList: res.data });
                    } else {
                        console.error("Couldn't get the user audio list")
                    }
                })
            .catch(err => this.showError(err));
    }

    playUserAudio = (uuid, audio_id) => {
        let speechURL = getUserAudioFile(uuid, audio_id);

        this.audioElem.src = speechURL;
        this.audioElem.play();
    }

    showError = (err, message) => {
        if (err) {
            console.error(err);
        }

        this.setState({
            hasError: true,
            prompt: message ? message : 'Failed to Connect. Try Refreshing the Page, or Restarting Recording',
            totalPrompt: 0
        });
    }


}

Speeches.propTypes = {
    uuid: PropTypes.string
};

export default Speeches;



// WEBPACK FOOTER //
// ./src/App/components/Speeches.js